<template>
  <cx-showcase-section :name="name" :link="link" class="cx-button-showcase">
    <div class="cxu-d-flex cxu-gap-10">
      <cx-button @click="handleClick" tooltip="click me!">Click me!</cx-button>
      <cx-button :disabled="true">I am disabled</cx-button>
      <cx-button :loading="true">I am loading</cx-button>
      <cx-button icon="mdi-eye" :tooltip="{ text: 'click me!', offsetTop: -5 }">Look</cx-button>
      <cx-button icon="map">On the map</cx-button>
      <cx-button icon="cx_unit">for unit</cx-button>
      <cx-button icon="delete"></cx-button>
    </div>
    <div class="cxu-mt-10 cxu-d-flex cxu-gap-10">
      <cx-button variantSecondary>I am a secondary</cx-button>
      <cx-button variantDark>I am dark</cx-button>
      <cx-button class="flat" icon="mdi-eye">I am flat</cx-button>
      <cx-button icon="delete" class="square"></cx-button>
      <cx-button flat variantSecondary icon="mdi-eye">I am flat variant secondary</cx-button>
      <cx-button flat variantDark icon="mdi-eye">I am flat variant dark</cx-button>
      <cx-button flat variantDark icon="mdi-eye" :loading="true">I am flat loading</cx-button>
    </div>
    <div class="cxu-mt-10 cxu-d-flex cxu-gap-10">
      <cx-button variantSecondary :disabled="true">I am a secondary</cx-button>
      <cx-button variantDark :disabled="true">I am dark</cx-button>
    </div>
    <div class="cxu-mt-10 cxu-d-flex cxu-gap-10">
      <cx-button variantSecondary :loading="true">I am a secondary</cx-button>
      <cx-button variantDark :loading="true">I am dark</cx-button>
    </div>
    <div class="cxu-mt-10 cxu-d-flex cxu-gap-10">
      <cx-button><cx-label label="This is label inside the button"></cx-label></cx-button>
      <cx-button><a href="https://miro.com/app/board/o9J_lDPoVY8=/">link inside the button</a></cx-button>
      <cx-button>
        <cx-icon icon="mdi-eye"/>
      </cx-button>
      <cx-button icon="delete">
        <template #before-content>
          <cx-icon icon="mdi-eye"/>
        </template>
        Button with slots
        <template #after-content>
          <cx-icon icon="mdi-eye"/>
        </template>
      </cx-button>
      <cx-button :style="{ width: 150 + 'px' }">Suuuuuuuuuuuuuuuuuuuuuuuper loooong buttttton that will be cliiiiiiiiiiiiiped</cx-button>
    </div>

    <div class="cxu-mt-10 cxu-d-flex cxu-gap-10 cxu-mb-100">
      <cx-button :loading="true"><cx-label label="This is label inside the button"></cx-label></cx-button>
      <cx-button :loading="true"><a href="https://redux.js.org/tutorials/fundamentals/part-1-overview">link inside the button</a></cx-button>
      <cx-button :loading="true">
        <cx-icon icon="mdi-eye"/>
      </cx-button>
      <cx-button icon="delete" :loading="true">
        <template #before-content><cx-icon icon="mdi-eye"/></template>
        Button with slots
        <template #after-content><cx-icon icon="mdi-eye"/></template>
      </cx-button>
      <cx-button :loading="true" :style="{ width: 150 + 'px' }">Suuuuuuuuuuuuuuuuuuuuuuuper loooong buttttton that will be cliiiiiiiiiiiiiped</cx-button>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxButton from '@/components/CxButton';
import CxIcon from '@/components/CxIcon';
import CxLabel from '@/components/CxLabel';

export default {
  name: 'CxButtonShowcase',
  components: {
    CxButton,
    CxIcon,
    CxLabel,
    CxShowcaseSection
  },
  data() {
    return {
      name: 'CxButton',
      link: 'https://miro.com/app/board/o9J_lDPoVY8=/?moveToWidget=3074457359810659613&cot=14'
    };
  },
  methods: {
    onSelectionChanged(data) {
      // eslint-disable-next-line no-console
      console.log('list selection changed: ', data);
    },
    handleClick() {
      // eslint-disable-next-line no-console
      console.log('button clicked');
    }
  },
};

</script>

<style lang="less">
@import '../../../common';

</style>